import React from "react"
import styled from "styled-components"
import H2 from "../typography/H2"

const IconHeadingTitle = ({ icon, title, className, transform }) => (
  <IconTitleWrapper className={className}>
    <StyledImg src={icon} alt={`${title} feature icon`} transform={transform} />
    <StyledH2>{title}</StyledH2>
  </IconTitleWrapper>
)

export default IconHeadingTitle

const IconTitleWrapper = styled.div`
  ${({ theme }) => theme.se`
    display: flex;
    align-items: center;
    
  `}
  ${({ theme }) => theme.desktop`
    width: 70%;
    justify-content: flex-start
    &.capture-lead-header{
      width: 40%;

    }
  `}
`

const StyledImg = styled.img`
  transform: ${(props) => props.transform || "scale(0.8)"};
  margin-right: 10px;
`

const StyledH2 = styled(H2)`
  text-align: left;

  ${({ theme }) => theme.se`
    font-size: 20px;
  `}

  ${({ theme }) => theme.phone`
    font-size: 23px;
  `}

  ${({ theme }) => theme.tablet`
   font-size: 30px;
  `}
`
